import { minValue, NumberInput, required, TextInput, useNotify, useRecordContext } from "react-admin";
import AssignmentIcon from "@mui/icons-material/Assignment";
import { Grid } from "@mui/material";

import { settings } from "app";
import { erasmusRequests } from "api/erasmusApi";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import FormModal from "server/components/Modals/FormModal";
import { documentErrorMessage } from "server/components/DownloadFile";
import { download } from "server/download";
import { toDateOnly } from "utils/helpers";

// The order is generated from data that lives nowhere on the record - the signatories and the
// report it is issued on are typed in every time, so the POST carries them and returns the pdf.
const BusinessTripOrderDialog = ({ label = "Заповед за командировка" }) => {
  const record = useRecordContext();
  const notify = useNotify();

  if (!record) return null;

  const handleConfirm = async data => {
    const payload = {
      ReportNumber: data.reportNumber?.trim(),
      ReportDate: toDateOnly(data.reportDate),
      ChiefAccountant: data.chiefAccountant?.trim(),
      ChiefLegal: data.chiefLegal?.trim(),
      InsuranceCoverage: data.insuranceCoverage,
    };

    try {
      await download(
        `${settings.gatewayApi}/${erasmusRequests.postBusinessTripOrder(record.id)}`,
        `business-trip-order-${record.id}.pdf`,
        "POST",
        payload,
      );
    } catch (err) {
      // keep the modal open so the entered data can be corrected and the download retried
      notify(documentErrorMessage(err), { type: "error" });
      return false;
    }
  };

  return (
    <FormModal
      titleContent={label}
      dialogSize="md"
      saveTitle="Генерирай"
      onConfirm={handleConfirm}
      startIcon={<AssignmentIcon />}
      titleButton={label}
      btnStyle={{ width: "max-content" }}
      variant="contained"
    >
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          xs={12}
          md={6}
        >
          <TextInput
            source="reportNumber"
            label="Номер на доклада"
            fullWidth
            validate={[required()]}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <CustomDateInput
            source="reportDate"
            label="Дата на доклада"
            noTime
            required={true}
            validate={required()}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <TextInput
            source="chiefAccountant"
            label="Главен счетоводител"
            fullWidth
            validate={[required()]}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <TextInput
            source="chiefLegal"
            label="Юрисконсулт"
            fullWidth
            validate={[required()]}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <NumberInput
            source="insuranceCoverage"
            label="Медицинско покритие (EUR)"
            fullWidth
            min={0}
            step={0.01}
            validate={[required(), minValue(0)]}
            onWheel={e => e.target.blur()}
          />
        </Grid>
      </Grid>
    </FormModal>
  );
};

export default BusinessTripOrderDialog;
